<template>
  <div
    :id="groupId + '-' + itemID"
    class="accordion-item border-b-2 border-white mb-4"
    :class="{ 'is-active': item.active }"
  >
    <dt class="accordion-item-title relative">
      <button @click="toggle" class="lg:pr-6 pt-4 pb-2.5 lg:pb-6 text-left w-full flex items-center">
        <span class="text-green-500 font-medium block text-lg lg:text-2lg" v-html="item.title"/>
        <svg id="chevron" class="icon icon-chevron ml-auto h-5 w-5 lg:h-7 lg:w-7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.621 34.242">
          <path fill="none" stroke="#478d7e" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="m2.122 2.122 15 15-15 15"/>
        </svg>
      </button>
    </dt>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <dd v-if="item.active" class="overflow-hidden">
          <div v-if="item.content" v-html="item.content" class="wyswyg text-gray-100 mb-4 lg:mb-8"></div>
          <template v-if="item.accordion_inner" >
             <accordion-item-inner
                  v-for="(item, index) in item.accordion_inner"
                  :multiple="multiple"
                  :item="item"
                  :parentCategory="category"
                  :groupId="groupId+index"
                  :key="index"
                  :itemID="index"
                />        
          </template>
      </dd>
    </transition>
  </div>
</template>

<script>
import AccordionItemInner from './accordionItemInner.vue';

export default {
  components: {
    AccordionItemInner
  },
  props: {
    groupId: {
      type: Number,
      default: 1,
    },
    category: {
      type: String,
      default: 1,
    },
    itemID: {
      type: Number,
      default: 1,
    },
    item: {
      type: Object,
      default: ()=>{},
    },
    multiple: {
      type: Boolean,
      default: ()=>{},
    },
  },
  methods: {
    toggle(event) {
      if (this.multiple) {
        this.item.active = !this.item.active;
      } else {
        this.$parent.$children.forEach((item, index) => {
          if (item.$el.id === event.currentTarget.parentElement.parentElement.id) {
            item.item.active = !item.item.active;
          } else {
            item.item.active = false;
          }
        });
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + "px";
    },

    endTransition(el) {
      el.style.height = "";
    },
  },
};
</script>
<style  >
.icon-chevron {
  transition: transform 0.2s ease; 
}
.is-active .icon {
  transform: rotate(90deg)
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}

.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>
